// extracted by css-extract-rspack-plugin
var _1 = "bh";
export { _1 as "locationInfoComponent" }
